import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Loading from "../../../loading";
import Snackbar from "../../../snackbar";
import { styles } from "./styles";
import Header from "../../../../partials/header";
import "../../../../css/serviceAlbum.css";
import Album from "./album";
class ServiceAlbum extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      colorSnackbar: "white",
    };
  }

  render() {
    const { classes, t } = this.props;

    return (
      <div className={classes.root}>
        <Snackbar
          color={this.state.colorSnackbar}
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />

        <Loading onRef={(id) => (this.loading = id)} />

        <Album />
      </div>
    );
  }
}

ServiceAlbum.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(ServiceAlbum)
  )
);
